/*
  File: src/api/teams.js
  Purpose: Teams API client for team management
  Notes:
  - Uses shared apiClient base URL and credentials.
  - Simple list operation for team selection in player management.
*/
import { apiClient } from '../auth/api';

export const TeamsAPI = {
    async list({ limit = 100, offset = 0 } = {}) {
        const params = {};
        if (limit != null) params.limit = limit;
        if (offset != null) params.offset = offset;
        const { data } = await apiClient.get('/teams', { params });
        return data;
    },

    async getById(teamId) {
        const { data } = await apiClient.get(`/teams/${teamId}`);
        return data;
    }
};

export default TeamsAPI;

